import { createSelector } from "reselect";

const selectFont = (state) => state.font;

export const selectCurrentFont = createSelector(
  [selectFont],
  (font) => font.currentFont
);
